import React, { useRef, useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import Tooltip from 'react-tooltip-lite';

import HelpIcon from '@material-ui/icons/Help';
import './ToolTipStyle.scss';

const TooltipWithHeading = ({ title, text, imgs, toolTip, headToolTipTranslate, values,
  iconStyles }) => {
  let tipContentRef = useRef('');
  let buttonRef = useRef('');
  const [openHelp, setopenHelp] = useState(false);

  useEffect(() => {
    const bodyClick = (e) => {
      if ((tipContentRef && tipContentRef.current && tipContentRef.current.contains(e.target))
       || (buttonRef && buttonRef.current && buttonRef.current.contains(e.target))) {
        return;
      }
      setopenHelp(false);
    };

    document.addEventListener('mousedown', bodyClick);
    return () => {
      document.removeEventListener('mousedown', bodyClick);
    };
  }, []);

  let styleObj = {
    fontSize: '1.4rem',
    paddingLeft: '3px',
    paddingBottom: '2px',
    marginBottom: '0.1rem',
    marginLeft: '0.2rem',
    cursor: 'pointer',
    color: '#8C9EA7'
  };

  const checkLink = value => (value ? (value?.includes('https://') || value?.includes('http://')) : false);
  const convertToLinks = textValue => textValue && textValue.replace(/(https?:\/\/[^\s]+?)([.,;!?]?)(\s|$)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>$2$3');
  const styleBreakWord = {
    wordBreak: 'break-word',
    overflow: 'auto',
    minHeight: '100%',
    maxHeight: '50vh'
  };

  return (
  <>
    <Tooltip
      content={
        <div ref={(el) => { tipContentRef.current = el; }}>
          {typeof text === 'string' && checkLink(text) ? (
            // eslint-disable-next-line react/no-danger
            <div style={styleBreakWord} dangerouslySetInnerHTML={{ __html: convertToLinks(text) }} />
          ) : (
          <>
            <h4 className="tip-heading">
              <FormattedMessage id={headToolTipTranslate || 'wildlife.strike.form.toolTip.heading'} defaultMessage={title} />
            </h4>
            <p style={styleBreakWord}><FormattedMessage id={toolTip} defaultMessage={text} values={values} /></p>
          </>
          )}
          {imgs?.length > 0 && imgs.map(val => <img src={val} key={val} alt="engine" />)}
        </div>}
      direction="right"
      tagName="span"
      isOpen={openHelp}
    >
      <HelpIcon
        style={styleObj}
        onClick={() => setopenHelp(!openHelp)}
        ref={(el) => { buttonRef.current = el; }}
        className={iconStyles}
      />
    </Tooltip>
  </>);
};

export default TooltipWithHeading;
